import { AppBar, Avatar, Box, Divider, ListItemIcon, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import React from 'react';
import MessageDialog from '../MessageDialog';
import { BrandConfig } from '../../config/brandConfig';
import { accountType } from '../../Objects/interfaces/accountInterface';

interface NavbarProps {
  index?: number;
  theme?: 'light' | 'dark';
  children: React.ReactNode
  brandConfig: BrandConfig
  anchorEl: null | HTMLElement
  handleAccountMenuClose: () => void
  accounts: accountType[]
  demoSession: {
    user: {
      image: string;
      name: string;
      email: string;
    }
  },
  scrolling: boolean,
  className?: string

}

const ElevatorAppBar = (props: NavbarProps) => {
  const { brandConfig, anchorEl, handleAccountMenuClose, accounts, demoSession, children, scrolling, className } = props;

  return (
    <>
      <MessageDialog />
      <AppBar
        elevation={0}
        className={`${className}`}
        sx={{ background: 'transparent', boxShadow: 'none' }}
      >
        {children}
      </AppBar>
      <Toolbar sx={{ minHeight: '80px !important' }} />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleAccountMenuClose}
        onClick={handleAccountMenuClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              fontFamily: brandConfig.fontFamily,
              mt: 1.5,
              minWidth: 256,
              borderRadius: '16px',
              boxShadow: '0 16px 48px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.06)',
              border: '1px solid rgba(0,0,0,0.06)',
              overflow: 'hidden',
              '& .MuiMenuItem-root': {
                px: 2,
                py: 1.25,
                mx: 1,
                my: 0.25,
                borderRadius: '10px',
                transition: 'all 0.15s ease',
                '&:hover': {
                  backgroundColor: `${brandConfig.colors.primary}0f`,
                },
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Box sx={{ px: 2.5, pt: 2, pb: 1.5, display: 'flex', gap: 1.5, alignItems: 'center' }}>
          <Avatar
            src={demoSession.user.image}
            sx={{
              width: 44, height: 44,
              border: `2px solid ${brandConfig.colors.primary}33`,
              boxShadow: `0 2px 10px ${brandConfig.colors.primary}22`,
            }}
          />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', color: '#111827', lineHeight: 1.3 }} noWrap>
              {demoSession.user.name}
            </Typography>
            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', lineHeight: 1.4 }} noWrap>
              {demoSession.user.email}
            </Typography>
          </Box>
        </Box>
        <Divider sx={{ mx: 2, mb: 0.5, borderColor: 'rgba(0,0,0,0.06)' }} />
        {accounts.map((account, index) => (
          <MenuItem
            key={index}
            onClick={account.triggle || undefined}
            sx={{
              fontFamily: brandConfig.fontFamily,
              color: '#374151',
              fontWeight: 500,
              fontSize: '0.875rem',
            }}
          >
            <ListItemIcon sx={{ minWidth: 36, color: brandConfig.colors.primary }}>
              {account.icon}
            </ListItemIcon>
            {account.title}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ElevatorAppBar;